import React from "react";
import {
  HEADING_TYPE,
  TEXT_TYPE,
  TEXT_VIEW_TYPE,
} from "../../constants/webapp";

export const useAccountDeletionForm = () => {
  const formFields = [
    {
      type: HEADING_TYPE,
      text: "Request for Account Deletion",
    },
    {
      type: TEXT_VIEW_TYPE,
      text: "Send a request to delete your account and personally identifiable information (PII) that is stored on our system. You will receive an email to verify your request. Once the request is verified we will take care of deleting your PII.",
    },
    {
      type: TEXT_VIEW_TYPE,
      text: (
        <b>
          Note: Your request for account deletion will be fulfilled within 3
          days.
        </b>
      ),
    },
    {
      id: "email",
      label: "Email Address",
      props: { type: "email" },
      type: TEXT_TYPE,
      required: true,
    },
  ];
  return { formFields };
};
